const lookupById = (list, id) =>
  (list || []).find(
    (item) => Number(item.id) === Number(id) || String(item._id) === String(id)
  );

export const parseListingLocation = (location) => {
  if (!location) return null;
  if (typeof location === 'object' && location.lat != null) return location;

  const str = String(location).trim();
  const coordMatch = str.match(/^(-?\d+\.?\d*)\s*,\s*(-?\d+\.?\d*)$/);
  if (coordMatch) {
    return {
      lat: parseFloat(coordMatch[1]),
      lng: parseFloat(coordMatch[2]),
      address: str,
    };
  }

  return { address: str };
};

export const carToFormPrefill = (car, context = {}, user = {}) => {
  const lookup = (sourceKey, id, nameKey) =>
    car[nameKey] || lookupById(context[sourceKey], id)?.name || '';

  return {
    name: user.name || '',
    phone: user.phone || '',
    brand: lookup('brands', car.brand_id, 'brand_name'),
    model: lookup('model', car.model_id, 'model_name'),
    body_type: lookup('body_type', car.body_type_id, 'body_type_name'),
    fuel: lookup('fuel_type', car.fuel_type_id, 'fuel_name'),
    transmission: lookup('transmission', car.transmission_id, 'transmission_name'),
    color: lookup('car_color', car.color_id, 'color_name'),
    seats: lookup('seats', car.seats_id, 'seats_name'),
    state: lookup('state', car.state_id, 'state_name'),
    city: lookup('city', car.city_id, 'city_name'),
    sub_register: lookup('sub_register', car.sub_register_id, 'sub_register_name'),
    year: car.year ?? '',
    km_driven: car.km_driven ?? '',
    tire_wear: car.tire_wear != null ? String(car.tire_wear) : '',
    price: car.price ?? '',
    youtube: car.youtube || '',
    youtube_shorts: car.shorts || '',
  };
};
